/* eslint-env browser */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-cond-assign */
/* eslint-disable no-redeclare */
/* eslint-disable no-bitwise */
export var canUseDOM = function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};
export function isNode(node) {
  return node && typeof node.nodeType === 'number' && typeof node.nodeName === 'string';
}
export var isElement = function isElement(node) {
  return isNode(node) && node.nodeType === 1;
};
export var isTextNode = function isTextNode(node) {
  return isNode(node) && node.nodeType === 3;
};
export var isEmptyTextNode = function isEmptyTextNode(node) {
  return isTextNode(node) && node.nodeValue === '';
};
export var isEmptyElement = function isEmptyElement(node) {
  return isElement(node) && (node.childNodes.length === 0 || node.childNodes.length === 1 && (isEmptyTextNode(node.firstChild) || isEmptyElement(node.firstChild)));
};
export var isBody = function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
};
export var isWindow = function isWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
};
export var ownerDocument = function ownerDocument(node) {
  return node && node.ownerDocument || document;
};
export var ownerWindow = function ownerWindow(node) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var doc = ownerDocument(node);
  return doc.defaultView || doc.parentVindow || fallback;
};

/**
 * Cross browsers, and cross elements `contains`.
 * HTML DOM and SVG DOM may have different support levels,
 * so we need to check on parentNode instead of a document root element.
 * IE doesn't support `contains` on SVG elements.
 */
export var contains = function contains(parentNode, node) {
  if (!canUseDOM()) return false;
  if ('contains' in parentNode) {
    return parentNode.contains(node);
  }
  if ('compareDocumentPosition' in parentNode) {
    return parentNode === node || !!(parentNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY);
  }
  do {
    if (node === parentNode) return true;
  } while (node = node.parentNode);
  return false;
};